import React, { useEffect } from "react";
import { Card, Row, Col, Button, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../MonthlySalaryReportSlice";
import { SearchOutlined } from "@ant-design/icons";
import { fetchMonthlySalaryReport } from "../MonthlySalaryReportThunk";
import { getMonth, getYear } from "../../../lib/yearMonth";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import dayjs from "dayjs";

const MonthlySalaryReportFilters = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.monthlySalaryReport);
  const months = getMonth();
  const years = getYear();

  useEffect(() => {
    if (!filters.attendanceDate) {
      const currentDay = dayjs();
      const formattedDay = currentDay.format("YYYY-MM-DDTHH:mm:ss");
      dispatch(
        setFilters({
          attendanceDate: formattedDay,
        })
      );
    }
  }, [dispatch, filters.attendanceDate]);

  useEffect(() => {
    if (!filters.month || !filters.year) {
      const currentMonth = dayjs().format("MMMM"); // e.g., "September"
      const currentYear = dayjs().year(); // e.g., 2025

      dispatch(
        setFilters({
          month: currentMonth,
          year: currentYear,
        })
      );
    }
  }, [ ]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleSubmit = () => {
    dispatch(fetchMonthlySalaryReport({ filters }));
  };

  return (
    <Card className="page-filters mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
          <label>Select Pay of Year</label>
          <SearchListAutoComplete
            optionsList={years.map((m) => ({
              sale_id: m.year,
              display_text: m.year,
              raw: m,
            }))}
            value={ filters.year ? {
              sale_id: filters.year,
              display_text: filters.year,
            } : undefined}
            onSelect={(obj) => handleFilterChange("year", obj?.sale_id)}            
            placeholder="Year"
            showAddNew={false}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
          <label>Select Pay of Month</label>
          <SearchListAutoComplete
            optionsList={months.map((m) => ({
              sale_id: m.month,
              display_text: m.month,
              raw: m,
            }))}
            value={filters.month ?{
              sale_id: filters.month,
              display_text: filters.month,
            } : undefined}
            onSelect={(obj) => handleFilterChange("month", obj?.sale_id)}            
            placeholder="Month"
            showAddNew={false}
          />
        </Col>

        <Col
          xs={24}
          sm={12}
          md={9}
          lg={4}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            data-testid="get-report-button"
          >
            Get Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .page-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  `}</style>
    </Card>
  );
};

export default MonthlySalaryReportFilters;
